'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record, Set as ImmutableSet } from 'immutable';
import GeolocationRecord from '../audiences/GeolocationRecord';
import AudienceNetworkStateRecord from '../audiences/AudienceNetworkStateRecord';
export const AdWordsLanguageRecord = Record({
  code: null,
  adWordsId: null,
  name: null
});

class AdCreationSearchTargetingRecord extends Record({
  locations: ImmutableSet(),
  audiences: ImmutableSet(),
  languages: ImmutableSet(),
  searchNetwork: true,
  displayNetwork: true,
  estimatedSize: null
}) {
  static getTargetingFromDraft(__network, {
    locations = [],
    audiences = [],
    languages = [],
    searchNetwork,
    displayNetwork
  }) {
    return new AdCreationSearchTargetingRecord({
      locations: ImmutableSet(locations.map(loc => new GeolocationRecord(loc))),
      audiences: ImmutableSet(audiences.map(audience => new AudienceNetworkStateRecord(audience))),
      languages: ImmutableSet(languages),
      searchNetwork,
      displayNetwork
    });
  }

  constructor(_ref) {
    let {
      locale,
      languages
    } = _ref,
        opts = _objectWithoutPropertiesLoose(_ref, ["locale", "languages"]);

    super(Object.assign({
      languages: languages ? languages.map(lang => AdWordsLanguageRecord(lang)) : locale && ImmutableSet([AdWordsLanguageRecord(locale)])
    }, opts));
  }

  getRequestData() {
    return {
      targetingOptions: {
        googleUserListCriteria: this.audiences.map(audience => ({
          id: audience.id
        })).toArray(),
        googleLocationCriteria: this.locations.map(location => ({
          id: location.key
        })).toArray(),
        languageConstantIds: this.languages.map(language => language.adWordsId).toArray(),
        googleNetworkSettings: {
          targetSearchNetwork: this.searchNetwork,
          targetContentNetwork: this.displayNetwork
        }
      }
    };
  }

}

export default AdCreationSearchTargetingRecord;